import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import Modal from '../modal';
import ModalHeader from '../modal-header';
import ModalBody from '../modal-body';
import ModalFooter from '../modal-footer';
import {t} from 'common/utils/translation-util';

export default class ConfirmationModal extends React.Component {
  static propTypes = {
    body: PropTypes.any.isRequired,
    buttonProps: PropTypes.object,
    className: PropTypes.string,
    header: PropTypes.any.isRequired,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    buttonProps: {
      children: t('Delete'),
      type: 'red',
    },
    onCancel: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };

    this.cancelled = this.cancelled.bind(this);
    this.confirmed = this.confirmed.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
  }

  cancelled() {
    this.props.onCancel();
    this.hide();
  }

  confirmed() {
    this.props.onConfirm();
    this.hide();
  }

  hide() {
    this.setState({
      modalIsOpen: false,
    });
  }

  show() {
    this.setState({
      modalIsOpen: true,
    });
  }

  render() {
    const classList = ['ConfirmationModal'];
    if (this.props.className) {
      classList.push(this.props.className);
    }

    return (
      <Modal className={classList.join(' ')} isOpen={this.state.modalIsOpen}>
        <ModalHeader>{this.props.header}</ModalHeader>
        <ModalBody style={{whiteSpace: 'pre-wrap'}}>
          {this.props.body}
        </ModalBody>
        <ModalFooter
          onCancel={this.cancelled}
          onSave={this.confirmed}
          saveButtonProps={this.props.buttonProps}
        />
      </Modal>
    );
  }
}
